import type { AppResponseChatSessionResponse, ChatSessionResponse } from "@agent-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import type { MaybeRef } from "vue";
import { computed, toValue } from "vue";
import { agentServiceRequest } from "@/services/utils";

export const getChatSessionQueryKey = (chatSessionId: MaybeRef<string | undefined>) => [
  "get-chat-session-by-id",
  toValue(chatSessionId),
];

export const useGetChatSession = <TData = ChatSessionResponse>(
  chatSessionId: MaybeRef<string | undefined>,
  useQueryOptions?: UseQueryOptions<ChatSessionResponse, Error, TData>,
) => {
  const queryKey = computed(() => getChatSessionQueryKey(chatSessionId));

  return useQuery<ChatSessionResponse, Error, TData>({
    queryKey,
    queryFn: async (): Promise<ChatSessionResponse> => {
      const response: AxiosResponse<AppResponseChatSessionResponse> = await agentServiceRequest({
        method: "get",
        url: `/chat_sessions/${toValue(chatSessionId)}`,
      });
      return response.data.data!;
    },
    ...useQueryOptions,
  });
};
